var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"col-3 p-2"},[_c('div',{staticClass:"game-card skeleton-card"},[_c('div',{staticClass:"game-image skeleton"}),_c('p',{staticClass:"skeleton-text"}),_c('p',{staticClass:"skeleton-text"})])])
}]

export { render, staticRenderFns }